import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

import { MedNotification } from "./types";
import { NOTIFICATION_TYPES } from "./NOTIFICATION_TYPES.enum";

@Injectable({
  providedIn: "root",
})
export class MedNotificationService {
  list = new Subject<MedNotification[]>();
  clearList = new Subject<string>();

  add(item: MedNotification = {}) {
    this.list.next([item]);
  }

  addList(list: MedNotification[]) {
    if (!list.length) {
      return;
    }

    this.list.next(list);
  }

  success(text: string, config: MedNotification = {}): void {
    this.add(Object.assign({ type: NOTIFICATION_TYPES.SUCCESS, text }, config));
  }

  error(text: string, config: MedNotification = {}): void {
    this.add(Object.assign({ type: NOTIFICATION_TYPES.ERROR, text }, config));
  }

  info(text: string, config: MedNotification = {}): void {
    this.add(Object.assign({ type: NOTIFICATION_TYPES.INFO, text }, config));
  }

  clear(key?: string) {
    this.clearList.next(key || "");
  }
}
